const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Retail Money. Not Wholesale Scraps.',
    description:
      'Trade-ins are designed to lowball you — that\'s how dealers make money on the back end. Consignment puts you on the retail side of that equation. Same car, significantly more cash.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'We Handle the Strangers.',
    description:
      'No Craigslist meetups. No 11pm texts. No test drives with people who "just want to look." We field every inquiry, vet every buyer, and you never have to deal with any of it.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Your Car Is Covered.',
    description:
      'While it\'s on our lot, it\'s under our dealer insurance policy. Test drives, lot incidents, weather — all covered. You\'re not taking on any liability by letting us sell it.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Marketing That Actually Works.',
    description:
      'Professional photos, a listing that reads like a human wrote it, and distribution across every platform buyers actually use. Not a three-word description and one blurry photo.',
  },
  {
    icon: 'ri-time-line',
    title: 'You Stay in Control.',
    description:
      'Set your floor price. Change your mind. Pull the car if your plans shift. We work for you — not the other way around. No pressure, no locked-in contracts.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'No Surprises at the End.',
    description:
      'You know our fee upfront. You approve every offer before we accept it. When the car sells, the math is simple: sale price minus flat fee equals your check. That\'s it.',
  },
];

export default function ConsignmentBenefits() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
            Why Consignment Beats Every Other Option
          </h2>
          <div className="w-24 h-1 bg-[#E8B84B] mx-auto mb-6"></div>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#374151' }}>
            Private sale is a part-time job. Trade-in is a rip-off. This is neither.
          </p>
        </div>

        <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 list-none" aria-label="Consignment benefits">
          {benefits.map((benefit, index) => (
            <li
              key={index}
              className="bg-[#F7F5F0] rounded-2xl p-8 border-2 border-[#E8E2D6] hover:border-[#E8B84B] transition-all group"
            >
              <div className="w-16 h-16 bg-[#E8B84B] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-3xl text-[#1C2B1E]`} aria-hidden="true"></i>
              </div>
              <h3 className="font-['Oswald'] text-2xl font-bold text-[#1C2B1E] mb-3">
                {benefit.title}
              </h3>
              <p style={{ color: '#374151' }} className="leading-relaxed">{benefit.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
